var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import "pixi-spine";
import "pixi.js";
import { utilAnimation } from "../utils/animation/utilAnimation";
var Container = PIXI.Container;
import { getRandomIdWalkingCitizen, getRandomWalkingCitizenAnimation, } from "./WalkingCitizenConfiguration";
var WalkingCitizen = /** @class */ (function (_super) {
    __extends(WalkingCitizen, _super);
    function WalkingCitizen() {
        var _this = _super.call(this) || this;
        _this.animScale = 0.35;
        _this.animTrackIdx = 0;
        _this.startAnimation = function (animation) {
            _this.spineAnimation.state.setAnimation(_this.animTrackIdx, animation, false);
        };
        _this.init = function () {
            _this.spineAnimation = utilAnimation.getSpineAnimation(_this.id);
            _this.spineAnimation.pivot.set(_this.spineAnimation.width * 0.25, _this.spineAnimation.height * 0.25);
            _this.spineAnimation.scale.set(_this.animScale, _this.animScale);
            _this.startRandomAnimation();
            _this.addChild(_this.spineAnimation);
        };
        _this.startRandomAnimation = function () {
            _this.startAnimation(_this.animation);
        };
        _this.id = getRandomIdWalkingCitizen();
        _this.animation = getRandomWalkingCitizenAnimation(_this.id);
        utilAnimation.getAnimLoaded$(_this.id).subscribe(_this.init);
        return _this;
    }
    return WalkingCitizen;
}(Container));
export { WalkingCitizen };



//////////////////
// WEBPACK FOOTER
// ./src/graphics/WalkingCitizen.ts
// module id = 2201
// module chunks = 3